module.exports = __webpack_public_path__ + "img/tpc-posters-1.6b25e336.webp";